import React from "react";

import Logo from "../base/logo";
import { brand } from "../../../configs/brand";

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="auth-container">
      <Logo />
      <h1 className="logo-header">{brand.tagline}</h1>
      {children}
    </div>
  );
};

export default AuthLayout;
